import React, { Fragment } from 'react';
import GetCertificate from '../../CertificateRequest/GetCertificate';

export default class NewStudentCertificate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Fragment><GetCertificate
                    closeGetRequestMode={() => this.setState({
                        getCertificate: false, loading: false, firstName: '', lastName: '', index: '', show: false
                    })}
                    studentStudyProgramId={JSON.parse(localStorage.getItem('student')).id}
                    student={JSON.parse(localStorage.getItem('student'))}
                    locked={JSON.parse(localStorage.getItem('student')).locked}
                    studyProgramStudentSwitchedToId={JSON.parse(localStorage.getItem('student')).studyProgramStudentSwitchedToId}
                    studentCertificate
                    droppedOut={JSON.parse(localStorage.getItem('student')).dateOfAbandonment !== null}
                    graduationDate={JSON.parse(localStorage.getItem('student')).graduationDate !== null}
                /></Fragment>
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/NewStudentCertificate.js